import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import CouponCreate from '../../components/ActiveCode/CouponCreate';
import LicenseView from '../../components/Join/LicenseView';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'createdAt', label: '가입일', minWidth: 140, align: 'center' },
  { id: 'managerId', label: 'ID', minWidth: 140, align: 'center' },
  { id: 'managerName', label: '담당자 이름', minWidth: 100, align: 'center' },
  { id: `companyName`, label: '회사', minWidth: 100, align: 'center' },
  { id: `companyNo`, label: '사업자번호', minWidth: 100, align: 'center' },
  { id: 'managerName', label: '담당자 이름', minWidth: 100, align: 'center' },
  { id: `couponDate`, label: '사용권 구매일', minWidth: 100, align: 'center' },
  { id: `orderQuantity`, label: '구매 사용권', minWidth: 100, align: 'center' },
  { id: `couponQuantity`, label: '잔여 사용권', minWidth: 100, align: 'center' },
  { id: `scaleNm`, label: '승인여부', minWidth: 100, align: 'center' }
];

export default function CompanyMng() {
  const [srchData, setSrchData] = useState({ scale: 'N' });
  const [datas, setDatas] = useState({ scale: 'N', Users: {} });
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);

  const [scales, setScales] = useState([]);
  const [dgCds, setDgCds] = useState([]);
  const [sgguCds, setSgguCds] = useState([]);
  const [memberCnt, setMemberCnt] = useState('-');

  const [liCenseOpen, setLiCenseOpen] = useState(false);
  const [open, setOpen] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
    setValue('datas', { ...datas, [e.target.id]: e.target.value }, { shouldValidate: true, shouldDirty: true });
  };

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const handleChangeSrchScaleSelect = (e) => {
    setSrchData({ ...srchData, scale: e.target.value });
  };

  const handleChangeScale = (e) => {
    setDatas({ ...datas, scale: e.target.value });
    setValue('datas', { ...datas, scale: e.target.value }, { shouldValidate: true, shouldDirty: true });
  };

  const handleRowClick = (data) => async (evt) => {
    initForm();
    data.preScale = data.scale;
    setDatas(data);
    setValue('datas', data);
    getSgguCodeList(data?.dgCd);
    const scale = await getScale(data);
    setMemberCnt(scale.jnngpCnt);
  };

  const handleChangeDgCdSelect = (e) => {
    setDatas({ ...datas, dgCd: e.target.value });
    getSgguCodeList(e.target.value);
  };

  const handleChangeSgguCdSelect = (e) => {
    setDatas({ ...datas, sgguCd: e.target.value });
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLicenseOpen = () => {
    setLiCenseOpen(true);
  };

  const handleLicenseClose = () => {
    setLiCenseOpen(false);
  };

  const getDataList = async (e) => {
    const { userid, username, companyName, companyNo, scale } = srchData;
    let params = {
      offset,
      page,
      limit: offset,
      userid,
      username,
      companyName,
      companyNo,
      scale
    };

    const response = await axios.get(`/api/company`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  const getScale = async (data) => {
    const response = await axios.get(`/api/company/scale`, { params: data });
    return response.data;
  };

  const initForm = () => {
    setDatas({ scale: 'N', Users: {} });
    clearErrors();
    reset();
  };

  const companyUpdate = async (data) => {
    return await axios.patch(`/api/company/${data.id}`, { data });
  };

  const onSubmit = () => {
    if (isDirty) {
      companyUpdate(datas)
        .then((response) => {
          getDataList();
          initForm();
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const getScaleCodeList = async () => {
    await axios
      .get(`/api/code/scale`)
      .then((response) => {
        if (!!response.data) {
          setScales(response.data);
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const getDgCodeList = async () => {
    await axios
      .get(`/api/code/dg`)
      .then((response) => {
        if (!!response.data) {
          setDgCds(response.data);
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const getSgguCodeList = async (dgCd) => {
    await axios
      .get(`/api/code/${dgCd}`)
      .then((response) => {
        if (!!response.data) {
          setSgguCds(response.data);
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  useEffect(() => {
    getDataList(page);
  }, [page]);

  useEffect(() => {
    getScaleCodeList();
    getDgCodeList();
  }, []);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        회사 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <Stack direction="row" spacing={2}>
            <TextField id="companyNameSrch" variant="outlined" size="small" label="회사명" value={srchData?.companyName || ''} onChange={handleChangeSrch} />
            <TextField id="companyNoSrch" variant="outlined" size="small" label="사업자등록번호" value={srchData?.companyNo || ''} onChange={handleChangeSrch} />
            <TextField id="usernameSrch" variant="outlined" size="small" label="사용자명" value={srchData?.username || ''} onChange={handleChangeSrch} />
            <TextField id="useridSrch" variant="outlined" size="small" label="아이디" value={srchData?.userid || ''} onChange={handleChangeSrch} />
            <Select labelId="dgCd-label" size="small" value={srchData?.scale || 'N'} label="승인여부" onChange={handleChangeSrchScaleSelect}>
              <MenuItem key={`scale-99`} value={'ALL'}>
                <ListItemText primary="전체" />
              </MenuItem>
              {scales.map((item, idx) => {
                return (
                  <MenuItem key={`scale-${idx}`} value={item.cdVal}>
                    <ListItemText primary={item.cdNm} />
                  </MenuItem>
                );
              })}
              <MenuItem key={`scale-00`} value={'Y'}>
                <ListItemText primary="승인" />
              </MenuItem>
            </Select>
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => (
                      <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                        {row[col.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
        <Grid item xs={3}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" type="submit" form="userInfoForm" disabled={datas.id ? false : true}>
              {datas.preScale === 'N' ? '승인' : '수정'}
            </Button>
            <Button variant="contained" onClick={handleClickOpen} disabled={datas.id && datas.preScale !== 'N' ? false : true}>
              사용권생성
            </Button>
          </Stack>
          <Box id="userInfoForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
            <TextField margin="dense" required fullWidth id="userid" label="ID" name="userid" value={datas?.managerId || ''} disabled={true} />
            <TextField
              margin="dense"
              required
              fullWidth
              name="companyName"
              label="회사명"
              id="companyName"
              value={datas?.companyName || ''}
              error={!!errors.datas?.companyName}
              helperText={errors.datas?.companyName && errors.datas?.companyName.message}
              {...register('datas.companyName', {
                required: '회사명을 입력해주세요.'
              })}
              onChange={handleChange}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="companyNo"
              label="사업자등록번호"
              id="companyNo"
              value={datas?.companyNo || ''}
              error={!!errors.datas?.companyNo}
              helperText={errors.datas?.companyNo && errors.datas?.companyNo.message}
              {...register('datas.companyNo', {
                required: '사업자등록번호를 입력해주세요.'
              })}
              style={{ width: `${datas.licenseFileName ? '74%' : '100%'}` }}
              onChange={handleChange}
            />
            {datas?.licenseFileName && (
              <Button variant="outlined" color="success" onClick={handleLicenseOpen} style={{ width: '25%', marginTop: 6, marginLeft: 3, height: 57 }}>
                사업자 등록증
              </Button>
            )}
            <FormControl sx={{ minWidth: 1 / 2 }}>
              <InputLabel id="dgCd-label">시도</InputLabel>
              <Select labelId="dgCd-label" id="dgCd" name="dgCd" value={datas?.dgCd || ''} label="시도" onChange={handleChangeDgCdSelect}>
                {dgCds.map((item, idx) => {
                  return (
                    <MenuItem key={`dgCd-${idx}`} value={item.cdVal}>
                      <ListItemText primary={item.cdNm} />
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl sx={{ minWidth: 1 / 2 }}>
              <InputLabel id="sgguCd-label">시군구</InputLabel>
              <Select labelId="sgguCd-label" id="sgguCd" name="sgguCd" value={datas?.sgguCd || ''} label="시군구" onChange={handleChangeSgguCdSelect}>
                {sgguCds.map((item, idx) => {
                  return (
                    <MenuItem key={`sgguCd-${idx}`} value={item.cdVal}>
                      <ListItemText primary={item.cdNm} />
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <TextField margin="dense" required fullWidth name="username" label="담당자 이름" id="username" value={datas?.managerName || ''} disabled={true} />
            <TextField margin="dense" required fullWidth name="eMail" label="E-mail" type="text" id="eMail" value={datas?.managerMail || ''} disabled={true} />
            <TextField margin="dense" required fullWidth name="phoneNumber" label="전화번호" id="phoneNumber" value={datas?.managerPhone || ''} disabled={true} />
            <TextField margin="dense" required fullWidth name="cellPhoneNumber" label="핸드폰 번호" id="cellPhoneNumber" value={datas?.managerCellPhone || ''} disabled={true} />
            <FormControl>
              <FormLabel required>규모</FormLabel>
              사원수 : {memberCnt}
              <RadioGroup name="scale" id="scale" value={datas?.scale} onChange={handleChangeScale}>
                {scales.map((item, idx) => {
                  return <FormControlLabel key={item.cdVal} value={item.cdVal} control={<Radio {...register('datas.scale')} />} label={item.cdNm} />;
                })}
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
      <CouponCreate open={open} handleClose={handleClose} id={datas.id} />
      <LicenseView open={liCenseOpen} handleClose={handleLicenseClose} licenseFileName={datas.licenseFileName} />
    </Paper>
  );
}
